import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-gradient border-t border-foreground-50/5">
      <div className="w-full px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-0">
          {/* Brand + social */}
          <div className="lg:w-2/5">
            <Link to="/" className="inline-block group">
              <span className="font-heading text-2xl tracking-[0.12em] uppercase text-foreground-50">
                Keaton Brown
              </span>
            </Link>
            <p className="text-foreground-400 text-sm mt-4 leading-relaxed max-w-xs">
              Keaton Brown | Baritone
            </p>
            <div className="flex items-center gap-5 mt-6">
              <a
                href="https://www.facebook.com/share/199vhZLZKK/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground-400 hover:text-foreground-50 hover:scale-110 transition-all duration-300"
                aria-label="Facebook"
              >
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/keabrown_"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground-400 hover:text-foreground-50 hover:scale-110 transition-all duration-300"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://www.youtube.com/channel/UCkGxUgyAnQMkplDOAeaWelg"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground-400 hover:text-foreground-50 hover:scale-110 transition-all duration-300"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="lg:w-1/5">
            <h4 className="text-foreground-50 text-xs tracking-[0.15em] uppercase mb-5 font-medium">Navigation</h4>
            <div className="flex flex-col gap-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'About', path: '/about' },
                { label: 'Schedule', path: '/schedule' },
                { label: 'Media', path: '/media' },
                { label: 'Gallery', path: '/gallery' },
                { label: 'Contact', path: '/contact' },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-foreground-400 hover:text-foreground-50 text-sm transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="lg:w-1/5">
            <h4 className="text-foreground-50 text-xs tracking-[0.15em] uppercase mb-5 font-medium">Contact</h4>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:keatonbrown98@gmail.com"
                className="text-foreground-400 hover:text-foreground-50 text-sm transition-colors duration-300"
              >
                keatonbrown98@gmail.com
              </a>
              <span className="text-foreground-400 text-sm">Houston, Texas</span>
            </div>
          </div>

          {/* Quick links */}
          <div className="lg:w-1/5">
            <h4 className="text-foreground-50 text-xs tracking-[0.15em] uppercase mb-5 font-medium">Performances</h4>
            <div className="flex flex-col gap-3">
              <a
                href="https://www.pointofdeparturehouston.com/coffeehouse-music-salon-1014"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground-400 hover:text-foreground-50 text-sm transition-colors duration-300"
              >
                Point of Departure
              </a>
              <a
                href="https://operanorthnh.org/fiddler/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground-400 hover:text-foreground-50 text-sm transition-colors duration-300"
              >
                Opera North
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-foreground-50/5 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-foreground-400 text-sm">
            &copy; {currentYear} Keaton Brown. All rights reserved.
          </p>
          <p className="text-foreground-400 text-sm">
            Baritone &mdash; Houston, Texas
          </p>
        </div>

        {/* Developer credit — centered, standalone */}
        <div className="mt-6 flex justify-center">
          <a
            href="https://clarkwebdesign.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#C9A84C] hover:text-[#D4B866] text-sm tracking-[0.06em] transition-colors duration-300 font-medium"
          >
            Developed by ClarkWebDesign
          </a>
        </div>
      </div>
    </footer>
  );
}